/*
 *
 * DisputeUciTimeoutModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 04-Jun-2026
 */

import React from 'react'
import PropTypes from 'prop-types'

// Components
import MerchantModal from '@nexidigital/merchantmodal'

// Texts
import formattedMessage from '../../modules/languageModule'

const DisputeUciTimeoutModal = (props) => {
  const handleClose = () => {
    props.actions.doHidePopup()
  }

  const handlePrimaryAction = () => {
    props.actions.doHidePopup()
    props.actions.doSetShopSelectionMode('checkbox', 'dispute-uci')
    props.actions.doGetDisputeShopList({ forcePopup: true })
  }

  return (
    <MerchantModal
      isOpen
      title={formattedMessage.timeoutModalTitle}
      description={formattedMessage.timeoutModalDescription}
      onClose={handleClose}
      primaryButtonLabel={formattedMessage.timeoutModalPrimaryButtonLabel}
      primaryAction={handlePrimaryAction}
      disableBackdropClick
    />
  )
}

DisputeUciTimeoutModal.propTypes = {
  actions: PropTypes.shape({
    doHidePopup: PropTypes.func,
    doSetShopSelectionMode: PropTypes.func,
    doGetDisputeShopList: PropTypes.func
  })
}

DisputeUciTimeoutModal.defaultProps = {
  actions: {}
}

export default DisputeUciTimeoutModal
